import React from "react";
import { withStyles } from "material-ui/styles";
import classnames from "classnames";

const fontSize = "1rem";

const styles = theme => ({
  common: {
    border: "none",
    cursor: "pointer",
    color: theme.palette.link,
    outline: 0
  },
  first: {
    fontSize,
    width: 40,
    padding: 0
  },
  prev: {
    fontSize,
    width: 22,
    margin: "0 5px",
    padding: 0
  },
  spread: {
    fontSize,
    width: 22,
    margin: "0 3px",
    cursor: "default",
    color: "inherit"
  },
  number: {
    fontSize,
    margin: 0
  },
  selected: {
    color: "black",
    cursor: "default"
  },
  next: {
    fontSize,
    width: 22,
    margin: "0 5px",
    padding: 0
  },
  last: {
    fontSize,
    width: 40,
    padding: 0
  },
  hide: {
    display: "none"
  }
});

const createPages = (page, totalPage) => {
  let pages = [...Array(totalPage)].map((u, i) => i + 1);
  pages = pages.length === 0 ? [1] : pages;

  if (pages.length <= 7) {
    // 何もしない
  } else if (page <= 4) {
    pages = pages.slice(0, 6);
  } else if (pages.length <= 8) {
    pages = pages.slice(2, 8);
  } else if (pages.length - 3 <= page) {
    pages = pages.slice(pages.length - 6, pages.length);
  } else {
    pages = pages.slice(page - 3, page + 2);
  }

  return pages;
};

const HeaderMenu = props => {
  const { classes, className, totalCount, perPage, page } = props;
  const { handleClick } = props;

  const totalPage = Math.ceil(totalCount / perPage) || 1;
  const pages = createPages(page, totalPage);

  return (
    <div className={className}>
      <span>ページ：</span>
      <button
        className={classnames(
          classes.common,
          classes.first,
          pages[0] === 1 && classes.hide
        )}
        onClick={() => page !== 1 && handleClick(1)}
      >
        最初
      </button>

      <button
        className={classnames(
          classes.common,
          classes.prev,
          page === 1 && classes.hide
        )}
        onClick={() => page !== 1 && handleClick(page - 1)}
      >
        前
      </button>

      <span
        className={classnames(
          classes.common,
          classes.spread,
          pages[0] === 1 && classes.hide
        )}
      >
        ...
      </span>

      {pages.map(_page => (
        <button
          key={_page}
          className={classnames(
            classes.common,
            classes.number,
            page === _page && classes.selected
          )}
          onClick={() => page !== _page && handleClick(_page)}
        >
          {_page}
        </button>
      ))}

      <span
        className={classnames(
          classes.common,
          classes.spread,
          pages[pages.length - 1] === totalPage && classes.hide
        )}
      >
        ...
      </span>

      <button
        className={classnames(
          classes.common,
          classes.next,
          page === totalPage && classes.hide
        )}
        onClick={() => page !== totalPage && handleClick(page + 1)}
      >
        次
      </button>

      <button
        className={classnames(
          classes.common,
          classes.last,
          pages[pages.length - 1] === totalPage && classes.hide
        )}
        onClick={() => page !== totalPage && handleClick(totalPage)}
      >
        最後
      </button>
    </div>
  );
};

export default withStyles(styles)(HeaderMenu);



// WEBPACK FOOTER //
// ./src/components/Pagination.jsx